import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { queryClient } from './lib/queries'
import { registerRouter } from './lib/navigation'
import { startPwaInstallWatch } from './lib/usePwaInstall'
import './styles/app.css'
// Applies the theme attribute at module scope, before the first React paint (§14.1).
import './stores/settings'

/**
 * HAS TO BE HERE, in the entry bundle, and not in the component that uses it.
 *
 * Chromium fires `beforeinstallprompt` once and early — routinely before the
 * reader's route chunk has even been fetched. Registering the listener from
 * `ViewSettings` (where the install button lives) therefore missed it, and the
 * button silently never appeared. This runs before `DOMContentLoaded`.
 */
startPwaInstallWatch()

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
})

/**
 * So `lib/commands.ts` can turn a page without a hook. Registered rather than imported
 * — see `lib/navigation.ts` for the import cycle this avoids.
 */
registerRouter(router)

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('#root not found')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
